var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      {
        staticClass: "bg-white ",
        staticStyle: {
          height: "calc(100% )",
          "overflow-y": "auto",
          position: "relative",
        },
      },
      [
        _vm.method != "add"
          ? _c(
              "el-button",
              {
                staticClass: "mb8",
                attrs: {
                  size: "medium",
                  icon: _vm.method == "view" ? "el-icon-edit" : "el-icon-view",
                  type: _vm.method == "view" ? "warning" : "primary",
                  plain: _vm.method == "view" ? false : true,
                  disabled: !_vm.hasPermission(
                    "cecunmportfolio:cecUnmPortfolio:edit"
                  ),
                },
                on: {
                  click: function ($event) {
                    return _vm.handEditorView(_vm.method)
                  },
                },
              },
              [_vm._v(_vm._s(_vm.method == "view" ? "编辑" : "取消"))]
            )
          : _vm._e(),
        _c(
          "el-form",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            ref: "inputForm",
            class: _vm.method === "view" ? "readonly" : "",
            attrs: {
              model: _vm.inputForm,
              size: "small",
              disabled: _vm.method === "view",
              "label-width": "150px",
            },
          },
          [
            _c(
              "el-row",
              [
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-divider",
                      { attrs: { "content-position": "left" } },
                      [_vm._v("产品基本信息")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "中文名称",
                          prop: "nameCn",
                          rules: [
                            {
                              required: true,
                              message: "中文名称不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请填写中文名称",
                            maxlength: "255",
                          },
                          model: {
                            value: _vm.inputForm.nameCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "nameCn", $$v)
                            },
                            expression: "inputForm.nameCn",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "英文名称",
                          prop: "nameEn",
                          rules: [
                            {
                              required: true,
                              message: "英文名称不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请填写英文名称",
                            maxlength: "255",
                          },
                          model: {
                            value: _vm.inputForm.nameEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "nameEn", $$v)
                            },
                            expression: "inputForm.nameEn",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "户型",
                          prop: "region",
                          rules: [
                            {
                              required: true,
                              message: "户型不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: { min: 1, max: 100 },
                          on: { change: _vm.handRegionText },
                          model: {
                            value: _vm.inputForm.bed,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "bed", $$v)
                            },
                            expression: "inputForm.bed",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              padding: "0 10px",
                              "font-size": "15px",
                            },
                          },
                          [_vm._v("Bed")]
                        ),
                        _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: { min: 1, max: 100 },
                          on: { change: _vm.handRegionText },
                          model: {
                            value: _vm.inputForm.bath,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "bath", $$v)
                            },
                            expression: "inputForm.bath",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              padding: "0 10px",
                              "font-size": "15px",
                            },
                          },
                          [_vm._v("Bath")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "排序",
                          prop: "sort",
                          rules: [
                            {
                              required: true,
                              message: "排序不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请填写排序" },
                          model: {
                            value: _vm.inputForm.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "sort", $$v)
                            },
                            expression: "inputForm.sort",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "状态",
                          prop: "state",
                          rules: [
                            {
                              required: true,
                              message: "状态不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.inputForm.state,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "state", $$v)
                              },
                              expression: "inputForm.state",
                            },
                          },
                          _vm._l(_vm.stateOption, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "创建时间",
                          prop: "createDate",
                          rules: [
                            {
                              required: true,
                              message: "创建时间不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "datetime",
                            placeholder: "选择日期时间",
                            align: "right",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "picker-options": _vm.pickerOptions,
                          },
                          model: {
                            value: _vm.inputForm.createDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "createDate", $$v)
                            },
                            expression: "inputForm.createDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "面积",
                          prop: "size",
                          rules: [
                            {
                              required: true,
                              message: "面积不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "70%" },
                          attrs: { placeholder: "请填写面积" },
                          on: {
                            input: function ($event) {
                              return _vm.handleInput($event, "size")
                            },
                            focus: function ($event) {
                              return _vm.focusInput($event, "size")
                            },
                            blur: function ($event) {
                              return _vm.blurInput($event, "size")
                            },
                          },
                          model: {
                            value: _vm.inputForm.size,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "size", $$v)
                            },
                            expression: "inputForm.size",
                          },
                        }),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              padding: "0 20px",
                              "font-size": "15px",
                            },
                          },
                          [_vm._v("sqft")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "地区",
                          prop: "houseType",
                          rules: [
                            {
                              required: true,
                              message: "地区不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.inputForm.houseType,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "houseType", $$v)
                              },
                              expression: "inputForm.houseType",
                            },
                          },
                          _vm._l(
                            _vm.$dictUtils.getDictList("cec_district"),
                            function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: {
                                  label: item.labelEn,
                                  value: item.value,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "价格",
                          prop: "price",
                          rules: [
                            {
                              required: true,
                              message: "价格不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请填写价格" },
                          on: {
                            input: function ($event) {
                              return _vm.handleInput($event, "price")
                            },
                            focus: function ($event) {
                              return _vm.focusInput($event, "price")
                            },
                            blur: function ($event) {
                              return _vm.blurInput($event, "price")
                            },
                          },
                          model: {
                            value: _vm.inputForm.price,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "price", $$v)
                            },
                            expression: "inputForm.price",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "类型",
                          prop: "type",
                          rules: [
                            {
                              required: true,
                              message: "类型不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择" },
                            model: {
                              value: _vm.inputForm.type,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "type", $$v)
                              },
                              expression: "inputForm.type",
                            },
                          },
                          _vm._l(
                            _vm.$dictUtils.getDictList("cec_portfolio_type"),
                            function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "标签", prop: "", rules: [] } },
                      [
                        _c("tags", {
                          attrs: {
                            tagsList: _vm.inputForm.tagsList,
                            disabled: _vm.method === "view",
                          },
                          on: { change: _vm.handTags },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-divider",
                      { attrs: { "content-position": "left" } },
                      [_vm._v("主图")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "是否在首页显示", prop: "showHome" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.inputForm.showHome,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "showHome", $$v)
                              },
                              expression: "inputForm.showHome",
                            },
                          },
                          _vm._l(
                            _vm.$dictUtils.getDictList("yes_no"),
                            function (item) {
                              return _c(
                                "el-radio",
                                { key: item.id, attrs: { label: item.value } },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "列表主图",
                          prop: "listImage",
                          rules: [
                            {
                              required: true,
                              message: "列表主图不能为空",
                              trigger: "change",
                            },
                          ],
                        },
                      },
                      [
                        _c("ImageUploadDraggable", {
                          attrs: {
                            disabled: _vm.method === "view",
                            limit: 1,
                            otherPrams: _vm.otherPrams,
                            action: "/unmfile/cecUnmFileupload",
                            tip: "单个图片不要超过10M",
                          },
                          on: {
                            updateChange: function ($event) {
                              return _vm.handImageList($event, "listImage")
                            },
                          },
                          model: {
                            value: _vm.inputForm.listImage,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "listImage", $$v)
                            },
                            expression: "inputForm.listImage",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "详情主图",
                          prop: "mainImage",
                          rules: [
                            {
                              required: true,
                              message: "详情主图不能为空",
                              trigger: "change",
                            },
                          ],
                        },
                      },
                      [
                        _c("ImageUploadDraggable", {
                          attrs: {
                            disabled: _vm.method === "view",
                            limit: 1,
                            otherPrams: _vm.otherPrams,
                            action: "/unmfile/cecUnmFileupload",
                            tip: "单个图片不要超过10M",
                          },
                          on: {
                            updateChange: function ($event) {
                              return _vm.handImageList($event, "mainImage")
                            },
                          },
                          model: {
                            value: _vm.inputForm.mainImage,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "mainImage", $$v)
                            },
                            expression: "inputForm.mainImage",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-divider",
                      { attrs: { "content-position": "left" } },
                      [_vm._v("设计")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "设计前图",
                          prop: "beforeImage",
                          rules: [
                            {
                              required: true,
                              message: "设计前图不能为空",
                              trigger: "change",
                            },
                          ],
                        },
                      },
                      [
                        _c("ImageUploadDraggable", {
                          attrs: {
                            disabled: _vm.method === "view",
                            limit: 1,
                            otherPrams: _vm.otherPrams,
                            action: "/unmfile/cecUnmFileupload",
                            tip: "单个图片不要超过10M",
                          },
                          on: {
                            updateChange: function ($event) {
                              return _vm.handImageList($event, "beforeImage")
                            },
                          },
                          model: {
                            value: _vm.inputForm.beforeImage,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "beforeImage", $$v)
                            },
                            expression: "inputForm.beforeImage",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "设计后图",
                          prop: "afterImage",
                          rules: [
                            {
                              required: true,
                              message: "设计后图不能为空",
                              trigger: "change",
                            },
                          ],
                        },
                      },
                      [
                        _c("ImageUploadDraggable", {
                          ref: "afterImageRef",
                          attrs: {
                            disabled: _vm.method === "view",
                            limit: 1,
                            otherPrams: _vm.otherPrams,
                            action: "/unmfile/cecUnmFileupload",
                            tip: "单个图片不要超过10M",
                          },
                          on: {
                            updateChange: function ($event) {
                              return _vm.handImageList($event, "afterImage")
                            },
                          },
                          model: {
                            value: _vm.inputForm.afterImage,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "afterImage", $$v)
                            },
                            expression: "inputForm.afterImage",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "设计后描点", prop: "", rules: [] } },
                      [
                        _c("designPoint", {
                          ref: "designPointRef",
                          attrs: {
                            title: "添加设计后描点",
                            disabled: _vm.method === "view",
                            valueList: _vm.inputForm.portfolioPoint,
                            backgroundImage: _vm.afterPonitImage,
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "设计内容（英）",
                          prop: "designConceptEn",
                          rules: [
                            {
                              required: true,
                              message: "设计内容（英）不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: { minRows: 5 },
                            placeholder: "请填写英文设计内容",
                          },
                          model: {
                            value: _vm.inputForm.designConceptEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "designConceptEn", $$v)
                            },
                            expression: "inputForm.designConceptEn",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "设计内容（中）",
                          prop: "designConceptCn",
                          rules: [
                            {
                              required: true,
                              message: "设计内容（中）不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: { minRows: 5 },
                            placeholder: "请填写中文设计内容",
                          },
                          model: {
                            value: _vm.inputForm.designConceptCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "designConceptCn", $$v)
                            },
                            expression: "inputForm.designConceptCn",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-divider",
                      { attrs: { "content-position": "left" } },
                      [_vm._v("材料")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "材料包装主图片",
                          prop: "itemImage",
                          rules: [
                            {
                              required: true,
                              message: "材料包装主图片不能为空",
                              trigger: "change",
                            },
                          ],
                        },
                      },
                      [
                        _c("ImageUploadDraggable", {
                          attrs: {
                            disabled: _vm.method === "view",
                            limit: 1,
                            otherPrams: _vm.otherPrams,
                            action: "/unmfile/cecUnmFileupload",
                            tip: "单个图片不要超过10M",
                          },
                          on: {
                            updateChange: function ($event) {
                              return _vm.handImageList($event, "itemImage")
                            },
                          },
                          model: {
                            value: _vm.inputForm.itemImage,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "itemImage", $$v)
                            },
                            expression: "inputForm.itemImage",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "材料包装其他图片集",
                          prop: "itemImageList",
                          rules: [
                            {
                              required: true,
                              message: "材料包装其他图片集不能为空",
                              trigger: "change",
                            },
                          ],
                        },
                      },
                      [
                        _c("ImageUploadDraggableBtn", {
                          ref: "itemImageJsonRef",
                          attrs: {
                            itemActivityForm: true,
                            ownerId: _vm.inputForm.id,
                            uploadInfo: {
                              type: "itemImageList",
                              title: "材料包装其他图片集",
                            },
                            setTable: true,
                            draggable: true,
                            disabled: _vm.disabledUpload,
                            otherPrams: _vm.otherPrams,
                            action: "/unmfile/cecUnmFileupload",
                            tip: "单个图片不要超过10M",
                          },
                          on: {
                            updateChange: function ($event) {
                              return _vm.handImageList($event, "itemImageList")
                            },
                          },
                          model: {
                            value: _vm.inputForm.itemImageList,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "itemImageList", $$v)
                            },
                            expression: "inputForm.itemImageList",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "材料内容（英）",
                          prop: "itemConceptEn",
                          rules: [
                            {
                              required: true,
                              message: "材料内容（英）不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: { minRows: 5 },
                            placeholder: "请填写英文材料包装内容",
                          },
                          model: {
                            value: _vm.inputForm.itemConceptEn,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "itemConceptEn", $$v)
                            },
                            expression: "inputForm.itemConceptEn",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "材料内容（中）",
                          prop: "itemConceptCn",
                          rules: [
                            {
                              required: true,
                              message: "材料内容（中）不能为空",
                              trigger: "blur",
                            },
                          ],
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: { minRows: 5 },
                            placeholder: "请填写中文材料包装内容",
                          },
                          model: {
                            value: _vm.inputForm.itemConceptCn,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "itemConceptCn", $$v)
                            },
                            expression: "inputForm.itemConceptCn",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-divider",
                      { attrs: { "content-position": "left" } },
                      [_vm._v("其他图片")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 24 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "展览集",
                          prop: "gallery",
                          rules: [
                            {
                              required: true,
                              message: "展览集不能为空",
                              trigger: "change",
                            },
                          ],
                        },
                      },
                      [
                        _c("ImageUploadDraggableBtn", {
                          attrs: {
                            draggable: true,
                            itemActivityForm: true,
                            ownerId: _vm.inputForm.id,
                            uploadInfo: { type: "gallery", title: "展览集" },
                            disabled: _vm.disabledUpload,
                            otherPrams: _vm.otherPrams,
                            action: "/unmfile/cecUnmFileupload",
                            tip: "单个图片不要超过10M,可拖动列表行排序",
                          },
                          on: {
                            updateChange: function ($event) {
                              return _vm.handImageList($event, "gallery")
                            },
                          },
                          model: {
                            value: _vm.inputForm.gallery,
                            callback: function ($$v) {
                              _vm.$set(_vm.inputForm, "gallery", $$v)
                            },
                            expression: "inputForm.gallery",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "clear" }),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c(
              "el-button",
              {
                attrs: {
                  size: "medium",
                  type: "danger",
                  icon: "el-icon-close",
                },
                on: {
                  click: function ($event) {
                    return _vm.closeSelectedTag()
                  },
                },
              },
              [_vm._v("关闭")]
            ),
            _vm.method != "view"
              ? _c(
                  "el-button",
                  {
                    directives: [
                      { name: "noMoreClick", rawName: "v-noMoreClick" },
                    ],
                    attrs: {
                      size: "medium",
                      type: "success",
                      icon: "el-icon-check",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.doSubmit()
                      },
                    },
                  },
                  [_vm._v("确定")]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }